import { axios } from '@/services/axios';

/**
 * Trunk types that can be assigned to a service profile.
 *
 * Same list SBCaaS uses at wholesaler level — not scoped to a platform, so
 * callers that need a specific platform's trunk type filter the result.
 */
const getAvailableTrunkTypes = async () => {
    const result = await axios.get('/TrunkTypes/Available');
    return result;
};

export default getAvailableTrunkTypes;
